// CSS Modules - component class name prefix: ShopCartLink__

<template>
  <span>
    <Button
      colour="orange"
      :text="waitingForResponse ? addButtonLoadingText : item.text"
      @onSimpleClick="addItem"
      :isDisabled="waitingForResponse"
    />
    <p
      v-if="addItemFailed"
      :class="[$style.errorText, { [$style.darkBackground]: isDarkBackground }]"
    >
      {{ addItemFailedMsg }}
    </p>
  </span>
</template>

<script>
import getQuoteIdFromUrl from "../../xhr/shopCart/getQuoteIdFromUrl";
import addItemToUrl from "../../xhr/shopCart/addItemToUrl";
import CustomEvents from "../../globals/constants/customEvents";
import Button from "../Button/Button";

export default {
  name: "ShopCartLink",
  components: { Button },
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    addButtonLoadingText: {
      type: String,
      default: ""
    },
    addItemFailedMsg: {
      type: String,
      default: ""
    },
    isDarkBackground: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      addItemFailed: false,
      waitingForResponse: false
    };
  },
  methods: {
    addItem() {
      this.addItemFailed = false;
      this.waitingForResponse = true;

      getQuoteIdFromUrl(window.getQuoteIdUrl)
        .then(quoteId => {
          addItemToUrl(window.addItemUrl, {
            itemid: this.item.id,
            quantity: this.item.quantity,
            country: window.currentCountry,
            language: window.currentLanguage,
            quoteid: quoteId,
            headline: this.item.headline,
            subheadline: this.item.subheadline,
            pictureurl: this.item.pictureurl,
            thumbnailurl: this.item.thumbnailurl,
            producturl: this.item.producturl
          })
            .then(response => {
              this.waitingForResponse = false;
              const event = new CustomEvent(CustomEvents.ADD_TO_CART, {
                detail: response.data
              });
              window.dispatchEvent(event);
              this.$emit("closed");
            })
            .catch(error => {
              this.addItemFailed = true;
              this.waitingForResponse = false;
              console.error(error);
            });
        })
        .catch(error => {
          this.addItemFailed = true;
          this.waitingForResponse = false;
          console.error(error);
        });
    }
  }
};
</script>

<style module lang="scss">
@import "./ShopCartLink.scss";
</style>
